import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { DESKTOP_BREAKPOINT } from '../constants';
var DEBOUNCE_DELAY = 275;
var ON_RESIZE_LISTENER = 'resize';
export var useMobileWidth = function useMobileWidth() {
  var _useState = useState(window.innerWidth),
      _useState2 = _slicedToArray(_useState, 2),
      windowWidth = _useState2[0],
      setWindowWidth = _useState2[1];

  var debouncedChangeWindowWidth = useDebouncedCallback(function () {
    setWindowWidth(window.innerWidth);
  }, DEBOUNCE_DELAY);
  useEffect(function () {
    window.addEventListener(ON_RESIZE_LISTENER, debouncedChangeWindowWidth);
    return function () {
      window.removeEventListener(ON_RESIZE_LISTENER, debouncedChangeWindowWidth);
    };
  }, [debouncedChangeWindowWidth]);
  return windowWidth < DESKTOP_BREAKPOINT;
};